import { useEffect, useState } from "react";
import { FilterTab } from "../../../components/Filters";
import RajProcurementForm from "./ProcurementForm.jsx";
import RajProcurementTable from "./ProcurementTable.jsx";
import { DynamicTab } from "../../../components/Page";
import { getProcurementRecord } from "../../../Rest_api/RestApi";
import { RajProcurementRecord } from "../../../models/rajasthan";
import { TabSwitcher } from "../Raj_Dashboard";

const TABS = ["Form", "Table"];
export function DemoRajProcurement() {
  return (
    <DynamicTab
      header="Procurement"
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        Form: <RajProcurementForm />,
        Table: <RajProcurementTable />,
      }}
    />
  );
}
